"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apolloXHR = exports.apolloFetch = void 0;
const ContextCookieHelper_1 = __importDefault(require("@aurora/shared-utils/authentication/ContextCookieHelper"));
const closeResponse_1 = __importDefault(require("@aurora/shared-utils/fetch/closeResponse"));
const log_1 = require("@aurora/shared-utils/log");
const FetchError_1 = __importStar(require("./FetchError"));
const log = (0, log_1.getLog)(module);
function requestInfo(options) {
    const { method, headers, credentials, mode, referrer, referrerPolicy } = options;
    return { method, headers, credentials, mode, referrer, referrerPolicy };
}
/**
 *  Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
 *  https://tools.ietf.org/html/rfc7230#section-3.2
 *
 *  @param rawHeaders the headers string from XHR.
 */
function parseHeaders(rawHeaders) {
    const headers = new Headers();
    const preProcessedHeaders = rawHeaders.replaceAll(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(line => {
        var _a, _b;
        const parts = line.split(':');
        const key = (_a = parts === null || parts === void 0 ? void 0 : parts.shift()) === null || _a === void 0 ? void 0 : _a.trim();
        if (key) {
            const value = (_b = parts === null || parts === void 0 ? void 0 : parts.join(':')) === null || _b === void 0 ? void 0 : _b.trim();
            headers.append(key, value);
        }
    });
    return headers;
}
function getOperationNames(fetchUrl) {
    const tokens = fetchUrl === null || fetchUrl === void 0 ? void 0 : fetchUrl.split('?opname=');
    return tokens.length > 1 ? [tokens[1]] : [];
}
/**
 * Create a new XHR instance for use specifically with Apollo.
 *
 * @param api the graphql API path.
 * @param onBeforeFetch a callback function that runs before the XHR is made.
 * @param options the Request options.
 * @param isSetXHRCredentials flag to check for setting credentials
 */
const apolloXHR = (api, onBeforeFetch, options, isSetXHRCredentials) => {
    const fetchUrl = api;
    const operationNames = getOperationNames(fetchUrl);
    log.trace('Fetching %s from %s with options: %O', operationNames, api, requestInfo(options));
    const now = performance.now();
    const call = () => {
        const customFetchPromise = new Promise((resolve, reject) => {
            var _a;
            const xhr = new XMLHttpRequest();
            if (isSetXHRCredentials) {
                xhr.withCredentials = true; // Adding the credentials to the XML Http request to pass on the cookies
            }
            xhr.addEventListener('load', () => {
                const responseOptions = {
                    status: xhr.status,
                    statusText: xhr.statusText,
                    headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                };
                const body = 'response' in xhr ? xhr.response : xhr.responseText;
                resolve(new Response(body, responseOptions));
            });
            xhr.addEventListener('error', () => {
                reject(new TypeError('Network request failed'));
            });
            xhr.addEventListener('timeout', () => {
                reject(new TypeError('Network request failed'));
            });
            xhr.open((_a = options.method) !== null && _a !== void 0 ? _a : 'POST', fetchUrl, true);
            const headers = options.headers;
            Object.keys(headers).forEach(key => {
                xhr.setRequestHeader(key, headers[key]);
            });
            if (xhr.upload) {
                xhr.upload.addEventListener('progress', options.onProgress);
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            xhr.send(options.body);
        });
        return customFetchPromise
            .then(response => {
            const responseObject = response;
            if ((responseObject === null || responseObject === void 0 ? void 0 : responseObject.status) < 400) {
                log.info('Fetched %s from %s in %dms', operationNames, api, performance.now() - now);
            }
            return responseObject;
        })
            .catch(error => {
            log.error(error, 'Network error fetching %s from %s', operationNames, api);
            throw error;
        });
    };
    onBeforeFetch(options);
    return call();
};
exports.apolloXHR = apolloXHR;
function doFetch(fetchUrl, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield fetch(fetchUrl, options);
        }
        catch (error) {
            log.error(error, 'Unknown fetch error at url: %s with options: %O', fetchUrl, options);
            throw error;
        }
    });
}
function fetchError(operationNames, api, status, message) {
    // log 401 at debug as it's usually a token timeout -- it will get handled higher up if it's real
    if (status === 401) {
        log.debug('401 response fetching %s from %s: { message: "%s" }', operationNames, api, message);
    }
    else {
        log.error('Error fetching %s from %s: { status: %d, message: "%s" }', operationNames, api, status, message);
    }
    return new FetchError_1.default(status, message);
}
function isRetryStatus(status) {
    return (status == FetchError_1.STATUS_CODE_UNAUTHORIZED ||
        status == FetchError_1.STATUS_CODE_TOO_MANY_REQUESTS ||
        status == FetchError_1.STATUS_CODE_TOO_BUSY);
}
/**
 * Create a new fetch instance for use specifically with Apollo.
 *
 * @param api the graphql API path
 * @param options the Request options.
 * @param onBeforeFetch a callback function that runs before the fetch is made.
 */
const apolloFetch = (api, options, onBeforeFetch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const now = performance.now();
    const fetchUrl = api;
    const operationNames = getOperationNames(fetchUrl);
    log.trace('Fetching %s from %s with options: %O', operationNames, api, requestInfo(options));
    if (onBeforeFetch) {
        onBeforeFetch(options);
    }
    const response = yield doFetch(fetchUrl, options);
    const status = response === null || response === void 0 ? void 0 : response.status;
    if (status < 400) {
        const nodeName = response.headers.get('x-li-node-name');
        const duration = (performance.now() - now).toPrecision(5);
        if (nodeName) {
            log.debug('Fetched %s from %s in %dms', operationNames, nodeName, duration);
        }
        else {
            log.debug('Fetched %s in %dms', operationNames, duration);
        }
        if (typeof window === 'undefined') {
            ContextCookieHelper_1.default.setContextCookies(response);
        }
    }
    else {
        const contentType = response === null || response === void 0 ? void 0 : response.headers.get('content-type');
        // guard against non-js content type so Apollo doesn't blow up on the body, as well as error status codes
        if (!(contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json'))) {
            yield (0, closeResponse_1.default)(response);
            throw fetchError(operationNames, api, status, response.statusText);
        }
        else {
            if (log.isLevelEnabled && log.isLevelEnabled('debug')) {
                log.debug('%d response fetching %s from %s with options %O', status, operationNames, api, Object.assign(Object.assign({}, options), { body: options.body ? ((_a = `${options.body}`) === null || _a === void 0 ? void 0 : _a.slice(0, 100)) + '...' : undefined //the body can be very long and isn't necessary, so truncate it
                 }));
            }
            else {
                if (status === FetchError_1.STATUS_CODE_UNAUTHORIZED) {
                    log.debug('%d response fetching %s from %s', status, operationNames, api);
                }
                else {
                    log.warn('%d response fetching %s from %s', status, operationNames, api);
                }
            }
            // don't close the response for retry codes
            if (!isRetryStatus(status)) {
                yield (0, closeResponse_1.default)(response);
            }
        }
    }
    return response;
});
exports.apolloFetch = apolloFetch;
//# sourceMappingURL=apolloFetch.js.map